module.exports = __webpack_public_path__ + "img/3-light.37de098f.png";